<template>
  <div class="appointmentList-view">
    <div style="float:right;margin-bottom:20px">
      <el-select v-model="value" :placeholder="$t('merchandise', 'pleaseSelect')" style="width: 240px">
        <el-option value="" :label="$t('merchandise', 'all')" class="cbcc">{{ $t('merchandise', 'all') }}</el-option>
        <el-option v-for="item in optionList" :key="item.productsTypeId" :label="item.productsTypeName"
          :value="item.productsTypeId">
        </el-option>
      </el-select>
      <el-date-picker v-model="queryDate" style="margin-left: 8px" align="right" type="date" :clearable="false"
        @change="dateChange" :placeholder="$t('merchandise', 'selectDate')">
      </el-date-picker>
      <el-button class="v-primary ml10" type="primary" @click="queryAppointmentPage">{{ $t('merchandise', 'query') }}</el-button>
    </div>
    <commonTable :tableData="tableData" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage" :loading="loading" :total="total">
      <template v-slot:table>
        <el-table-column prop="productsId" width="100" align="center" :label="$t('merchandise', 'productId')" />
        <el-table-column prop="productsName" align="center" :label="$t('merchandise', 'productName')" show-overflow-tooltip />
        <el-table-column prop="productsTypeName" show-overflow-tooltip align="center" :label="$t('merchandise', 'category')" />
        <el-table-column prop="price" show-overflow-tooltip align="center" :label="$t('merchandise', 'price')">
          <template slot-scope="scope"><span v-if="scope.row.price[1]">{{ scope.row.price[0] + "~" + scope.row.price[1]
          }}港元</span>
            <span v-else>{{ scope.row.price[0] }}港元</span>
          </template>
          <p></p>
        </el-table-column>
        <el-table-column prop="name" align="center" show-overflow-tooltip :label="$t('merchandise', 'userName')" />
        <el-table-column prop="phone" width="120" align="center" :label="$t('merchandise', 'appointmentPhone')">
          <template slot-scope="scope"><span style="color: #fe8575">{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" :label="$t('merchandise', 'orderTime')">
          <template slot-scope="scope"><span>{{ setDataTimeSec(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="appointmentTime" align="center" show-overflow-tooltip :label="$t('merchandise', 'appointmentTime')" />
        <el-table-column prop="remark" show-overflow-tooltip align="center" :label="$t('merchandise', 'remark')" />
        <el-table-column prop="applyRemark" show-overflow-tooltip align="center" :label="$t('merchandise', 'cancelReason')" />
        <el-table-column prop="state" align="center" :label="$t('merchandise', 'status')">
          <template slot-scope="scope"><span style="color: #fe8575">{{
            setState(scope.row.state)
          }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" align="center" :label="$t('merchandise', 'operation')">
          <template slot-scope="scope"><span style="color: #ff5c6c; cursor: pointer" @click="cancel(scope.row)"
              v-if="[1, 2].includes(scope.row.state)">
              {{ $t('merchandise', 'cancelAppointment') }}
            </span>
            <span style="color: #51cbcd; cursor: pointer" @click="affirm(scope.row)" v-if="scope.row.state == 1">
              {{ $t('merchandise', 'confirmAppointment') }}
            </span>
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import {
  fetchAppointmentPage,
  fetchProductsTypeList,
  alterAppointmentState,
} from "@/api/companyManage.js";
import { getDataTimeSec } from "@/utils";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  name: "appointmentList",
  components: {
    commonTable,
  },
  props: {
    jurisdiction: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userInfo: this.$store.state.loginRoot.userInfo,
      value: "",
      optionList: "", //全部分类
      tableData: [],
      total: 0, //总条数
      currentPage: 1, //当前页数
      queryDate: "",
      pageNum: 1,
      pageSize: 10,
      loading: false, //加载中
    };
  },
  computed: {
    setDataTimeSec() {
      return (data) => getDataTimeSec(data);
    },
    setState() {
      return (state) => {
        let obj = {
          1: this.$t('merchandise', 'pendingConfirm'),
          2: this.$t('merchandise', 'confirmed'),
          3: this.$t('merchandise', 'completed'),
          4: this.$t('merchandise', 'cancelled'),
          5: this.$t('merchandise', 'expired'),
        };
        return obj[state];
      };
    },
  },
  mounted() {
    this.getTableData();
    this.getTypeList();
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    //请求预约数据
    getTableData() {
      this.loading = true;
      let data = {
        ignore: true,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        productsTypeId: this.value,
        appointmentTime: this.queryDate || ''
      };
      fetchAppointmentPage(data)
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.pageInfo.list || "";
          this.total = res.data.pageInfo.total;
          this.tableData.forEach((v) => {
            v.price = JSON.parse(v.price);
            v.appointmentTime = `${getDataTimeSec(
              v.startTime
            )} - ${getDataTimeSec(v.endTime)}`;
          });
        })
        .catch((err) => {
          this.loading = false;
          this.tableData = [];
          console.log(err);
        });
    },
    //查询分类
    getTypeList() {
      fetchProductsTypeList({ ignore: true })
        .then((res) => {
          this.optionList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //筛选查询符合条件数据
    queryAppointmentPage() {
      this.currentPage = 1;
      this.pageNum = 1;
      this.getTableData();
    },
    //筛选时间
    dateChange(val) {
      this.queryDate = getDataTimeSec(val, "yy-mm-dd");
    },
    //取消
    cancel(val) {
      if (this.userInfo.roleId || this.jurisdiction) {
        this.$prompt(this.$t('merchandise', 'inputCancelReason'), this.$t('common', 'info'), {
          confirmButtonText: this.$t('common', 'confirm'),
          cancelButtonText: this.$t('common', 'cancel'),
        })
          .then(({ value }) => {
            let data = {
              appointmentId: val.appointmentId,
              state: 4,
              applyRemark: value,
            };
            this.changeOrderState(data);
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              type: "info",
              message: this.$t('merchandise', 'cancelInput'),
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: this.$t('merchandise', 'noPermission'),
        });
        return
      }
    },
    //确认
    affirm(val) {
      if (this.userInfo.roleId || this.jurisdiction) {
        this.$confirm(this.$t('merchandise', 'confirmAcceptAppointment'), this.$t('common', 'info'), {
          confirmButtonText: this.$t('common', 'confirm'),
          cancelButtonText: this.$t('common', 'cancel'),
          type: "info ",
        })
          .then(() => {
            let data = {
              appointmentId: val.appointmentId,
              state: 2,
            };
            this.changeOrderState(data);
          })
          .catch(() => { });
      } else {
        this.$message({
          type: "warning",
          message: this.$t('merchandise', 'noPermission'),
        });
        return
      }
    },
    // 修改订单状态
    changeOrderState(params) {
      alterAppointmentState(params).then((res) => {
        this.$message({
          type: "success",
          message: this.$t('merchandise', 'operationSuccess'),
        });
        this.getTableData();
      });
    },
    //当前页变更
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getTableData();
    },
    //当前页查询数据条数变更
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.currentPage = 1;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.appointmentList-view {
  background: #ffffff;
  padding: 24px;
}
</style>